
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { PaymentFormValues } from './types';

type FormInputProps = {
  form: UseFormReturn<PaymentFormValues>;
  name: keyof PaymentFormValues;
  label: string;
  placeholder: string;
  description?: string;
  type?: string;
}

export const FormInput: React.FC<FormInputProps> = ({
  form,
  name,
  label,
  placeholder,
  description,
  type = "text"
}) => (
  <FormField
    control={form.control}
    name={name}
    render={({ field }) => (
      <FormItem>
        <FormLabel>{label}</FormLabel>
        <FormControl>
          <Input placeholder={placeholder} type={type} {...field} />
        </FormControl>
        {description && <FormDescription>{description}</FormDescription>}
        <FormMessage />
      </FormItem>
    )}
  />
);
